import React from 'react';
import { Link } from 'react-router-dom';
import { RecordCell } from './Tables/RecordCells';

export const receivableServicePath = row => {
  const operation = row?.operation;
  if (!operation?.id) return null;
  return `/${Number(operation.is_motor) === 1 ? 'service-moto-detail' : 'service-detail'}/${operation.id}`;
};

export const ReceivableServiceCell = ({ row, canView }) => {
  const id = row.operation?.id || row.operation_id;
  const path = canView ? receivableServicePath(row) : null;
  return <RecordCell primary={id ? `#${id}` : '—'} secondary={row.operation?.vehicle?.plate || (id ? (row.operation ? null : 'Servis bulunamadı') : 'Bağımsız cari')} href={path} />;
};

export default function ReceivableServiceLink({ row, canView }) {
  const path = canView ? receivableServicePath(row) : null;
  return path ? <Link className="sz-record-action" data-row-action to={path} title={`Servise git #${row.operation.id}`} aria-label={`Servise git #${row.operation.id}`}><i className="fa fa-wrench" aria-hidden="true" /></Link> : null;
}
